import React, { useState, useEffect } from "react";
import stylelist from "stylelist";
import axios from "axios";

const Search = (props) => {

    // Search params (only user input!!)
    const [searchStrasse, setSearchStrasse] = useState("");
    const [searchHsnr, setSearchHsnr] = useState("");

    // Error-States for our both fields
    const [streetError, setStreetError] = useState(false);
    const [hsnrError, setHsnrError] = useState(false);

    // Autocomplete results from out API
    const [autoCompleteResults, setAutoCompleteResults] = useState([]);

    // Set, if the user has made a choice (which will disable autocomplete)
    const [userChoiceMade, setUserChoiceMade] = useState(false);

    // Send a request to our autocomplete-api when the street has changed
    useEffect(() => {
        if (searchStrasse) {
            // Build API-URL
            let k = new URL(document.location);
            k.searchParams.set("type", "1234");
            k.searchParams.set("street", searchStrasse);
            k.toString();

            // Send Request to the TYPO3-Plugin
            const autocompleteUrl = k.toString();
            axios.get(autocompleteUrl)
                .then((response) => {
                    // Set autocomplete results (which will update the state and re-render)
                    setAutoCompleteResults(response.data.data);
                })
                .catch(() => { });
        }

    }, [searchStrasse]);

    // Validate the form for simple mistakes
    const validateAndSendForm = () => {
        let error = false;

        // Check if Street is empty
        if (!searchStrasse) {
            setStreetError(true);
            error = true;
        } else {
            setStreetError(false);
        }

        // Check if Hsnr is empty
        if (!searchHsnr) {
            setHsnrError(true);
            error = true;
        } else {
            setHsnrError(false);
        }

        // Check, if we should proceed the form - or not
        if (!error) {

            let k = new URL(document.location);
            k.searchParams.set("type", "12346");
            k.searchParams.set("street", searchStrasse);
            k.searchParams.set("hsnr", searchHsnr);
            k.toString();

            // Send Request to the TYPO3-Plugin
            const availabilityUrl = k.toString();

            axios.post(availabilityUrl)
            .then((response)=>{
                if(response?.data) {
                    props.onSearchComplete(response.data);
                }
            })
            .catch(function (error) {
                props.onSearchComplete({availability:-1});
                console.log(error);
            });
        }
    }

    const fillAutocompleteEntry = (data) => {
        setSearchStrasse(data.strasse);
        setSearchHsnr(`${data.hsnr}${data.zstz}`);
        setUserChoiceMade(true);
    }

    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            validateAndSendForm();
        }
    }

    return <>
        <section className="bg-darkgreen availability-check">
            <div className="container-fluid bg-container">
                <div className="row">
                    <div className="col-md-offset-8 col-md-4 bg"/>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <h2>Fernwärme-Verfügbarkeitscheck</h2>
                        <p><span className="important">Sie wohnen in <strong>Hamm</strong> und haben Interesse, Fernwärme von den Stadtwerken Hamm zu beziehen? Prüfen Sie, ob Sie bereits im Versorgungsgebiet liegen oder für Ihre Adresse Planungen vorliegen:</span></p>
                        <div className="formee">
                            <form>
                                <fieldset>
                                    <legend>Fernwärme-Verfügbarkeitscheck</legend>
                                    <div className="row">
                                        {/* Start: Street-Searchfield */}
                                        <div className="col-md-5 col-lg-7">
                                            <div className={stylelist("form-group", [(streetError), "error"])}>

                                                {/* Start: Input: Street */}
                                                <label htmlFor="street" className="sr-only">Straße*</label>
                                                <input
                                                    className="form-control"
                                                    value={searchStrasse}
                                                    onClick={() => {setUserChoiceMade(false);}}                     // Disable UserChoice and enable Autocomplete again
                                                    onChange={(e) => { setSearchStrasse(e.target.value);!props.showSuggest?props.setShowSuggest(true):null}}          // Update Street-State
                                                    type="text"
                                                    name="street"
                                                    placeholder="Straße"
                                                    onKeyPress={handleKeyPress}
                                                />
                                                {/* End: Input: Street */}

                                                {/* Start: Autocomplete-Box */}
                                                {(autoCompleteResults?.length && !userChoiceMade && props.showSuggest) ?
                                                    <div className="autocomplete">
                                                        <>
                                                            {Object.values(autoCompleteResults).map((entry) => {
                                                                return (
                                                                    <div key= {entry.uid} onClick={() => { fillAutocompleteEntry(entry) }}>
                                                                        {entry.strasse} {entry.hsnr}{entry.zstz}, {entry.plz} {entry.stadt}
                                                                    </div>
                                                                )
                                                            })}
                                                        </>
                                                    </div>:null
                                                }
                                                {/* End: Autocomplete-Box */}

                                            </div>
                                        </div>
                                        {/* End: Street-Searchfield */}

                                        {/* Start: Housenumber-Searchfield */}
                                        <div className="col-md-3 col-lg-2">
                                            <div className={stylelist("form-group", [(hsnrError), "error"])}>

                                                {/* Start: Input: Housenumber */}
                                                <label htmlFor="housenumber" className="sr-only">Hausnr.*</label>
                                                <input
                                                    className="form-control"
                                                    value={searchHsnr}
                                                    onChange={(e) => { setSearchHsnr(e.target.value) }}             // Update Hsnr-State
                                                    type="text"
                                                    name="housenumber"
                                                    placeholder="Hausnr."
                                                    onKeyPress={handleKeyPress}
                                                />
                                                {/* Start: Input: Housenumber */}

                                            </div>
                                        </div>
                                        {/* End: Housenumber-Searchfield */}

                                        {/* Start: Searchbutton */}
                                        <div className="col-md-4 col-lg-3">
                                            <button type="button" className="btn btn-lightgreen" title="" onClick={() => { validateAndSendForm(); }}>Jetzt prüfen</button>
                                        </div>
                                        {/* End: Searchbutton */}

                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
}

export default Search;
